import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { DetailedChangeset } from 'ember-changeset/types';
import LocalityAutocomplete from 'garaje/components/locality-autocomplete';
import type SignInFieldModel from 'garaje/models/sign-in-field';
import { localCopy } from 'tracked-toolbox';

interface LocalityFieldComponentSignature {
  Args: {
    changeset: DetailedChangeset<SignInFieldModel>;
    update: (changeset: DetailedChangeset<SignInFieldModel>) => void;
    locality: { placeId: string };
    updateLocality: (locality: { placeId: string }) => void;
    disabled: boolean;
    type?: string;
  };
}

export default class LocalityFieldComponent extends Component<LocalityFieldComponentSignature> {
  @localCopy('args.disabled', false) disabled!: boolean;

  @action
  didChangeName(name: string): void {
    this.args.changeset.value = name;
    this.args.update(this.args.changeset);
  }

  @action
  didChangePlaceId(placeId: string): void {
    this.args.updateLocality({ placeId });
  }

  <template>
    <div data-test-flow-field={{@changeset.name}} class="relative mb-4">
      <label for={{@changeset.id}}>
        {{if @changeset.localized @changeset.localized @changeset.name}}
      </label>
      <LocalityAutocomplete
        @inputId={{@changeset.id}}
        @name={{@changeset.value}}
        @updateName={{this.didChangeName}}
        @placeId={{@locality.placeId}}
        @updatePlaceId={{this.didChangePlaceId}}
        @isDisabled={{this.disabled}}
        @type={{@type}}
      />
    </div>
  </template>
}
